//React
import { FunctionComponent } from "react";

//Interfaces
import { Result } from "../../models/result";

interface ResultImageProps {
	result: Result;
}

const ResultImage: FunctionComponent<ResultImageProps> = (props) => {
	//Properties
	const { result } = props;

	//JSX
	return (
		<img
			className="home-image"
			loading="lazy"
			src={result.imageSrc}
		/>
	);
};

export default ResultImage;
